import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import MatchDescriptionTable from '../MatchTimeline/Soccer/MatchDescriptionTable';
import TennisMatchDetails from '../MatchTimeline/Tennis/TennisMatchDetails';
import MatchDescriptionOddsTable from './Tennis/MatchDescriptionOddsTable';
import { aSetSelectedMarkets } from '../../reducers/oddsHistory';

const actionsToProps = (dispatch) => ({
  setSelectedMarkets: (payload) => dispatch(aSetSelectedMarkets(payload)),
});

/**
 * @class
 * @property {object} props
 */

class OddsHistory1 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedMarkets: [],
      allChecked: false,
    };
  }

  goToOddsHistory2 = () => {
    this.props.setSelectedMarkets({
      selectedMarkets: this.state.selectedMarkets,
    });
  };

  getAllMarkets = () => this.props.oddsHistoryTemplate.map((market) => market.id);

  toggleAllChecked = () => {
    if (this.state.allChecked) {
      this.setState({
        allChecked: false,
        selectedMarkets: [],
      });
    } else {
      const allMarkets = this.getAllMarkets();
      this.setState({
        allChecked: true,
        selectedMarkets: allMarkets,
      });
    }
  };

  renderDescTable = () => (
    this.props.isTennis
      ? (
        <MatchDescriptionOddsTable
          eventDetails={this.props.eventDetails}
        />
      )

      : (
        <MatchDescriptionTable
          eventDetails={this.props.eventDetails}
          leagues={this.props.leagues}
        />
      )
  );

  renderMatch = () => (
    this.props.isTennis
      ? (
        <TennisMatchDetails
          eventDetails={this.props.eventDetails}
        />
      )
      : (
        <div className="team-panel m-t-30">
          <span className="team-panel__txt">
            {this.props.eventDetails.teamHome.name}
            {' '}
            <span className="m-r-10 m-l-10">VS</span>
            {' '}
            {this.props.eventDetails.teamAway.name}
          </span>
        </div>
      )
  );

  handleOddsClick = (odd) => {
    let updatedMarkets = [...this.state.selectedMarkets];
    if (updatedMarkets.includes(odd)) {
      updatedMarkets = updatedMarkets.filter((market) => market !== odd);
    } else {
      updatedMarkets.push(odd);
    }
    this.setState({ selectedMarkets: updatedMarkets });
  };

  renderRow = (row) => (
    <div key={row[0].id} className="odds-type__row">
      {row.map((market) => (
        <div key={market.id} className="odds-type__select">
          <label className="checkbox">
            <input
              id={`selected-market-${market.id}`}
              type="checkbox"
              onChange={this.handleOddsClick.bind(this, market.id)}
              checked={this.state.selectedMarkets.includes(market.id)}
            />
            <div className="checkbox__icon m-r-20" />
            <span className="checkbox__label">{market.name}</span>
          </label>
        </div>
      ))}
    </div>
  );

  renderOddTableRow = () => {
    const newArr = [];
    for (let i = 0; i < this.props.oddsHistoryTemplate.length; i += 5) {
      newArr.push(this.renderRow(this.props.oddsHistoryTemplate.slice(i, i + 5)));
    }

    return newArr;
  };

  renderOddsTable = () => (
    <div className="odds-type m-t-30">
      <div className="odds-type__head">
        <div className="odds-type__head-txt">Odds types</div>
        <div className="odds-type__head-check">
          <label className="checkbox">
            <input id="checkbox__AllChecked" type="checkbox" className="checked--all" onChange={this.toggleAllChecked} checked={this.state.allChecked} />
            <div className="checkbox__icon m-r-20" />
            <span className="checkbox__label">Check/Uncheck All</span>
          </label>
        </div>
      </div>
      <div className="odds-type__content">
        {this.renderOddTableRow()}

      </div>
      <div className="odds-type__btn text-right">
        <div
          className="btn btn-secondary"
          onClick={() => this.props.navigate(-1)}
        >
          Cancel
        </div>
        <Link
          to={this.state.selectedMarkets.length > 0
            ? `${this.props.oddsStep2Page}/${this.props.matchId}`
            : `${this.props.oddsStep1Page}/${this.props.matchId}`}
          className={`btn btn-primary m-l-10 ${this.state.selectedMarkets.length === 0 ? 'disabled' : ''}`}
          onClick={this.navigateToStep2}
        >
          Continue
        </Link>
      </div>

    </div>
  );

  navigateToStep2 = () => {
    if (this.state.selectedMarkets.length > 0) {
      this.goToOddsHistory2();
    }
  };

  renderOddsHistory = () => {
    if (this.props.eventDetails && this.props.matchTimeline) {
      return (
        <>
          {this.renderDescTable()}
          {this.renderMatch()}
          {this.renderOddsTable()}
        </>
      );
    }
    return null;
  };

  render() {
    return (
      <>
        {this.renderOddsHistory()}
      </>
    );
  }
}

export default connect(null, actionsToProps)(OddsHistory1);
